import React, {useEffect, useState} from "react";

import { connect } from "react-redux";
import { userActions } from "../../actions";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import {formatSqlDate} from "../../helpers";

function UserList(props) {

    const { authentication, users, getUserList } = props;
    const user_id = authentication.user.user_id;
    const userList = users?.list;

    const addicon = require("../../images/add.png").default;

    const [workingUserList, setWorkingUserList] = useState(userList);

    useEffect(() => {
        getUserList(user_id);
        setWorkingUserList(userList);
    }, []);

    
    
    const headers = ["Email", "Name", "Org", "Last Login"];
    const tableHeaders = headers.map((header, i) => <th key={i}>{header}</th>);
    

    const filterWorkingUserList = (e) => {
      const value = e.target.value.toLowerCase();
      if (value === '') {
        setWorkingUserList(userList);
      } else {
        setWorkingUserList(userList.filter(user => (
          user.first_name.toLowerCase().includes(value) || 
          user.last_name.toLowerCase().includes(value) || 
          user.email.toLowerCase().includes(value) || 
          user.org_name.toLowerCase().includes(value))));
      }
      
      
    }
        
    const renderUserList = workingUserList?workingUserList:userList;
    const tableRows = renderUserList?.map((user, i) => (
      <tr key={i + '-' + user.user_id}>
      
      <td>
        <b>
          <Link
            to={{
              pathname: "/user/" + user.user_id,
              state: { user_to_edit: user },
            }}
          >
            {user.email}
          </Link>
        </b>
      </td>

      <td>
            {user.first_name + ' ' + user.last_name}
      </td>

      <td>
        <Link
          to={{
            pathname: "/org/" + user.org_id + "/users",
            state: {},
          }}
        >
          {user.org_name}
        </Link>
      </td>

      <td>
        {formatSqlDate(user.last_login)}
      </td>

    </tr>
    ));

    return (
    <div>
      <div className="searchMain">
        <div>
          <h3>
            Users
            &nbsp;&nbsp;&nbsp;
            {authentication.user.roles.includes("ADMIN") && (
              <>
                <div className="editJacketNameIcon" data-tip data-for="add user">
                  <Link
                    to={{
                      pathname: "/user/add",
                    }}
                  >
                    <img src={addicon} width="20px" alt="add" />
                  </Link>
                </div>
                <ReactTooltip id="add user" place="bottom" effect="solid" data-type="info" delayShow={300}>
                  create new user
                </ReactTooltip>
              </>
            )}

          </h3>
          <table className="listFilterTable">
            <tbody>
              <tr>
                <td>filter:</td>
                <td><input type="text" onChange={filterWorkingUserList}></input></td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <table className="paleBlueRows">
          <thead>
            <tr>
              {tableHeaders}
            </tr>
          </thead>
          <tbody>
            {tableRows}
          </tbody>
        </table>
      </div>
      <div className="pageFooterBuffer">
        &nbsp;
      </div>
    </div>
    );

} 


function mapStateToProps(state) {
    const { authentication, users } = state;
    return {
      authentication,
      users,
    };
  }
  
  const actionCreators = {
    getUserList: userActions.getList,
  };
  
  const connectedUserList = connect(mapStateToProps, actionCreators)(UserList);
  export { connectedUserList as UserList };
  